<template>
	<div class="maintenance-container">
		<img :src="img" alt="" />
	</div>
</template>

<script>
import img from '@/assets/images/maintenance.jpg';
export default {
	computed: {
		img() {
			return img;
		},
	},
};
</script>

<style>
body {
	background-color: #eee;
}
.maintenance-container {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	padding: 0 20px;
	background-color: #eee;
}
.maintenance-container > img {
	max-width: 100%;
}
</style>
